import { ccenum } from '@/utils/functions'

export enum BundleNames {
  gameicons = 'gameicons',
}

export enum Country {
  India = 1,
  Bangladesh = 2,
  Pakistan = 3,
  USA = 4,
}

// export const CountryAreaCode = {
//     1: 91,
//     2: 880,
//     3: 92,
// }

export const Languages = {
  en: 0,
  //"my": 1,
  pak: 1,
}

export const LanguageL10nKeys = {
  0: 'en',
  //1: "my",
  1: 'pak',
}

export const LanguageNames = {
  0: 'English',
  //1: "မြန်မာဘာသာ",
  1: 'اردو',
}

export enum HallTabViews {
  HallPanel = 'HallPanel',
  RankPanel = 'RankPanel',
  SharePanel = 'SharePanel',
  DepositPanel = 'DepositPanel',
  AccountPanel = 'AccountPanel',
}

export enum GameType {
  PLAYED = 0,
  All = 1,
  HotGame = 2,
  Slots = 3,
  TableCard = 4,
  Casino = 5,
  Arcade = 6,
  Fishing = 7,
  Lottery = 8,
}

export enum Providers {
  All = 0,
  PG = 1,
  FaChai = 2,
  PP = 3,
  Bng = 4,
  JILI = 5,
  Hacksaw = 6,
  SP = 7,
  Bgaming = 8,
  TADA = 9,
  NextSPIN = 10,
  EV = 11,
  WONWON = 12,
  CQ9 = 13,
  AOG = 14,
  RED = 15,
  V8 = 16,
  JDB = 17,
  InOut = 18,
  KoolBet = 19,
  Mini = 20,
}

export const GameTypeKeys = [
  '',
  'allList',
  'hotList',
  'slotsList',
  'tableCardList',
  'casinoList',
  'crashList',
  'fishingList',
  'lotteryList',
]

export const GameTypeNames = [
  '',
  '',
  'Hot Games',
  'Slot',
  'Table&Card',
  'Casino Live',
  'Arcade',
  'Fishing Games',
  'Lottery',
]

export const ProvidersKeys = [
  '',
  'pgSoftList',
  'fachaiList',
  'pragmaticPlayList',
  'bngList',
  'jiLiList',
  'hacksawList',
  'spribeList',
  'bgamingList',
  'tadaList',
  'nextSpinList',
  'evolutionLiveList',
  'wonwonList',
  'cq9List',
  'aogList',
  'redTigerList',
  'v8List',
  'jbdList',
  'inOutList',
  'koolBetList',
  'miniList',
]

export const ProvidersNames = [
  '',
  'PG',
  'FaChai',
  'Pragmatic Play',
  'BNG',
  'JILI',
  'Hacksaw',
  'Spribe',
  'Bgaming',
  'TADA',
  'NextSPIN',
  'Evolution',
  'WONWON',
  'CQ9',
  'AOG',
  'Red Tiger',
  'V8',
  'JDB',
  'InOut',
  'KoolBet',
  'Mini',
]

export enum BankType {
  oldBank = 0,
  eWallet = 1,
  newBank = 2,
}

export enum EWalletType {
  BKASH = 'BKASH',
  NAGAD = 'NAGAD',
  EASYPAISA = 'EASYPAISA',
  JAZZCASH = 'JAZZCASH',
}

export enum TransactionType {
  All = 0,
  Won = 1,
  Lose = 2,
  MoneyAdded = 3,
  Withdraw = 4,
  Activity = 5,
}
// Enum(TransactionType)

export const TransactionTypeNames = {
  0: 'ALL',
  1: 'Won',
  2: 'Lose',
  3: 'Money Added',
  4: 'Withdrawal',
  5: 'Activity',
}

export const TransactionTypeNamesTr = {
  0: 'Tüm İşlem Kaydı',
  1: 'Kazanç Geçmişi',
  2: 'Kayıp Geçmişi',
  3: 'Yatırım Geçmişi',
  4: 'Çekim Geçmişi',
  5: 'Promosyon Geçmişi',
}

export const TransactionTypeNamesMy = {
  0: 'အားလုံး​',
  1: 'အောင်မြင်ပြီး​',
  2: 'ရှုံးနိမ့်ပြီး​',
  3: 'ငွေထပ်ဖြည့်',
  4: 'ငွေထုတ်ခြင်း​',
  5: 'လှုပ်​',
}

export const TransactionTypeNamesPak = {
  0: 'تمام',
  1: 'جیت',
  2: 'کھو',
  3: 'پیسے شامل',
  4: 'واپسی',
  5: 'سرگرمی',
}

// 状态
export const TransactionStatus = {
  0: 'under review',
  1: 'success',
  2: 'refuse',
  102: 'fail',
  101: 'fail',
}

export enum PopupViews {
  TurnTablePanel = 'TurnTablePanel',
  SignPanel = 'SignPanel',
  VipCardPanel = 'VipCardPanel',
  VipRewardPanel = 'VipRewardPanel',
  PayWheelPanel = 'PayWheelPanel',
  VipConversionPanel = 'VipConversionPanel',
  WelcomePopPanel = 'WelcomePopPanel',
  NewBindActivityPanel = 'NewBindActivityPanel',
  VipEquityView = 'VipEquityView',
  PinDuoPopPanel = 'PinDuoPopPanel',
  RankRewardPanel = 'RankRewardPanel',
  RegisterBindPhonePanel = 'RegisterBindPhonePanel',
  PinDuoShowPopPanel = 'PinDuoShowPopPanel',
  BindingPhonePanel = 'BindingPhonePanel',
  FirstDepositPanel = 'FirstDepositPanel',
  WaterWheelPanel = 'WaterWheelPanel',
  BonanzaPanel = 'BonanzaPanel',
  FreeSpinViewX = 'FreeSpinViewX',
  DailyTaskPanel = 'DailyTaskPanel',
  BindingBeforePanel = 'BindingBeforePanel',
  JackpotgamsPanel = 'JackpotgamsPanel',
}

export enum AutoScrollDirection {
  Left = 0,
  Right = 1,
  Top = 2,
  Bottom = 3,
}

ccenum(AutoScrollDirection)

export enum SharePlatforms {
  FaceBook = 'https://www.facebook.com/sharer/sharer.php?u=',
  Telegram = 'https://t.me/share/url?url=',
  Twitter = 'https://twitter.com/intent/tweet?text=@t&url=',
  Whatsapp = 'https://api.whatsapp.com/send?text=',
  Instapaper = 'http://www.instapaper.com/edit?url=',
  Customer = 'https://plugin-code.salesmartly.com/js/project_600459_619640_1768276016.js',
}
export enum AppEvents {
  Login = 'Login', //登录
  CompleteRegistration = 'CompleteRegistration', //完成注册
  Purchase = 'Purchase', //充值
  FirstPurchase = 'FirstPurchase', //首充
}

export enum PixelEvents {
  Login = 'View Content', //登录 （访问您关心的网页（例如，商品页面或落地页）。）
  CompleteRegistration = 'Complete registration', //完成注册 （填写完注册表单时。）
  Purchase = 'Purchase', //充值（完成购买或结账流程时）
  FirstPurchase = 'first_deposit', //首充
}
